import template from './atm_load_profile.create.html';
import controller from './atm_load_profile.create.controller';
import './atm_load_profile.create.controller';

let ATMLoadProfileCreateComponent = {
  restrict: 'E',
  bindings: {
    hasACL: '='
  },
  template,
  controller
};

export default ATMLoadProfileCreateComponent;


// WEBPACK FOOTER //
// ./client/app/components/tnt_control/component/atm_load_profile/create/atm_load_profile.create.component.js